import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChatSupportComponent } from "../../utils/chat-support/chat-support.component";
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ApiService } from '../../core/services/ApiService.service';
import { PlanesComponent } from './planes/planes.component';
import { BeneficiosComponent } from './beneficios/beneficios.component';
import { beneficio } from '../../interfaces/appItnterfaces';


@Component({
  selector: 'app-home',
  imports: [
    CommonModule,
    RouterModule,
    NgOptimizedImage,
    ChatSupportComponent,
    PlanesComponent,
    BeneficiosComponent,
    CollapseModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  // imageUrl: string = 'assets/images/banner/bg-xl.webp';
  imageUrl: string = 'assets/images/banner/bg-main-xxl.webp';
  collapsedPreguntasFrecuentes: boolean = false;
  isMediumScreen: boolean = false

  mostrarImagen: boolean = false

  beneficios: beneficio[] = []

  @ViewChild('plan') public plan?: ElementRef;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // // this.loadAmoForms();
      //  setTimeout(() => {
      //   //  this.loadKommo()
      //    this.loadAmoForms();
      //   //  this.moveFormWhenReady();
      //  }, 3000);
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.responsiveImage()
      this.getSizeScreen()
      this.getBeneficios()
    }
  }

  getBeneficios() {
    this.apiService.getResource('beneficios.json').subscribe({
      next: (resp: any) => {
        this.beneficios = resp
      },
      error: (error: any) => {
        this.beneficios = []
      }
    })
  }

  responsiveImage() {
      if (isPlatformBrowser(this.platformId)) {
        this.breakpointObserver.observe([
          Breakpoints.XSmall,
          Breakpoints.Small,
          Breakpoints.Medium,
          Breakpoints.Large,
          Breakpoints.XLarge
        ]).subscribe(result => {
          if (result.matches) {
            if (result.breakpoints[Breakpoints.XSmall]) {
              this.imageUrl = 'assets/images/banner/bg-s.webp';
              this.imageUrl = 'assets/images/banner/bg-main-xs.webp';
              // this.isMediumScreen = true
            } else if (result.breakpoints[Breakpoints.Small]) {
              // this.imageUrl = 'assets/images/banner/bg-s.webp';
              this.imageUrl = 'assets/images/banner/bg-main-xs.webp';
              // this.isMediumScreen = true
            } else if (result.breakpoints[Breakpoints.Medium]) {
              // this.imageUrl = 'assets/images/banner/bg-m.webp';
              this.imageUrl = 'assets/images/banner/bg-main-md.webp';
              // this.isMediumScreen = true
            } else if (result.breakpoints[Breakpoints.Large]) {
              // this.imageUrl = 'assets/images/banner/bg-l.webp';
              this.imageUrl = 'assets/images/banner/bg-main-lg.webp';
              // this.isMediumScreen = false
            } else if (result.breakpoints[Breakpoints.XLarge]) {
              // this.imageUrl = 'assets/images/banner/bg-xl.webp';
              this.imageUrl = 'assets/images/banner/bg-main-xl.webp';
              // this.isMediumScreen = false
            } else if (result.breakpoints[Breakpoints.Web]) {
              this.imageUrl = 'assets/images/banner/bg-main-xxl.webp';
            }
          }
        });
      }
  }

  toggleVerMas(){
    this.collapsedPreguntasFrecuentes = !this.collapsedPreguntasFrecuentes
  }

/**
 * @method getSizeScreen: Método para verificar el tamaño de la pantalla.
 */
  getSizeScreen() {
    if(isPlatformBrowser(this.platformId)){

      try {
        const width = window.innerWidth;
        if(width > 991) {
          this.isMediumScreen = false
        } else {
          this.isMediumScreen = true
        }
      } catch (error) {}
     
      addEventListener("resize", (event) => {
          var width = window.innerWidth;
  
          if(width > 991) {
            this.isMediumScreen = false
          } else {
            this.isMediumScreen = true
          }
      });
    }
  }

  goToPlan() {
    this.plan?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
  }
 
  goToLink () {
    window.open('https://wa.link/xpjtot', '_blank');
  }

  private loadKommo(): void {
    if (document.getElementById('amoforms_script_1427027')) return;

    const w = window as any;

    w.amo_forms_params = w.amo_forms_params || {
      setMeta: function (p: any) {
        this.params = (this.params || []).concat([p]);
      }
    };

    w.amo_forms_load = w.amo_forms_load || function (f: any) {
      (w.amo_forms_load.f = w.amo_forms_load.f || []).push(f);
    };

    w.amo_forms_loaded = w.amo_forms_loaded || function (f: any, k: any) {
      (w.amo_forms_loaded.f = w.amo_forms_loaded.f || []).push([f, k]);
    };

    w.amo_forms_load({
      id: '1427027',
      hash: '9acc64e141fe197231743f2e082bee15',
      locale: 'es'
    });

    const script = document.createElement('script');
    script.id = 'amoforms_script_1427027';
    script.src = 'https://forms.kommo.com/forms/assets/js/amoforms.js';
    script.async = true;
    script.charset = 'utf-8';

    document.body.appendChild(script);
  }

  private moveFormWhenReady(): void {
    const slot = document.getElementById('kommo-slot');
    if (!slot) return;

    const observer = new MutationObserver(() => {
      const form = document.querySelector('[id^="amoforms_container_"]');
      if (form) {
        slot.appendChild(form);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  private loadAmoForms(): void {
  (function (a: any, m: any, o: any, c: any, r: any, m2: any) {
    a[o + c] = a[o + c] || {
      setMeta: function (p: any) {
        this.params = (this.params || []).concat([p]);
      }
    };

    a[o + r] = a[o + r] || function (f: any) {
      a[o + r].f = (a[o + r].f || []).concat([f]);
    };

    a[o + r]({
      id: "1639963",
      hash: "5cb0c17d69adb26904a3842855c18e50",
      locale: "es",
      container_id: "amoforms-target"
    });

    a[o + m2] = a[o + m2] || function (f: any, k: any) {
      a[o + m2].f = (a[o + m2].f || []).concat([[f, k]]);
    };
  })(window, 0, "amo_forms_", "params", "load", "loaded");

  if (!document.getElementById('amoforms_script_1639963')) {
    const script = document.createElement('script');
    script.id = 'amoforms_script_1639963';
    script.async = true;
    script.charset = 'utf-8';
    script.src = 'https://forms.kommo.com/forms/assets/js/amoforms.js';
    document.body.appendChild(script);
  }
}

  /**
   * @method downloadPdf
   * @description Abre el modal para descargar un archivo PDF.
   * Establece mostrarImagen en true para mostrar la interfaz de descarga.
   * @returns {void}
   */
  downloadPdf() {
    this.mostrarImagen = true
  }

  closeModalPdf() {
    this.mostrarImagen = false
  }


}
